import { Component } from '@angular/core';

@Component({
  selector: 'app-content-division',
  template: `<hr class="division" />`,
  styleUrls: ['./content-division.component.scss'],
})
export class ContentDivisionComponent {}
